/**
 * Adds a value to the end of a buffer array and ensures the buffer does not exceed a specified maximum size.
 *
 * @param buffer - The array to which the value will be added.
 * @param value - The value to add to the buffer.
 * @param maxSize - The maximum allowed size of the buffer.
 * @returns A new array with the value added, trimmed to the maximum size if necessary.
 */
export function pushWithMaxSize<Type>(buffer: Type[], value: Type, maxSize: number): Type[] {
  const newBuffer = [...buffer, value];

  return newBuffer.length > maxSize ? newBuffer.slice(-maxSize) : newBuffer;
}
